import React from 'react'
import { DragSource } from 'react-dnd'
import * as styles from './PuzzlePiece.module.scss'

const Piece = props => {
  const {
    image,
    x,
    y,
    connectDragSource,
    isOver,
    width,
    rows,
    puzzleMaxWidth,
    puzzleMaxHeight,
  } = props
  const height = width * 0.75 // 4:3 aspect ratio
  const length = width < puzzleMaxWidth ? height / rows : puzzleMaxHeight / rows

  return connectDragSource(
    <div
      className={styles.puzzleTile}
      style={{
        height: `${length}px`,
        width: `100%`,
        backgroundImage: `url(${image})`,
        backgroundSize: `${width < puzzleMaxWidth ? width : puzzleMaxWidth}px ${
          width < puzzleMaxWidth ? height : puzzleMaxHeight
        }px`,
        backgroundPosition: `-${x}px -${y}px`,
        opacity: `${isOver ? '0.2' : '1'}`,
      }}
    ></div>,
  )
}

const pieceSource = {
  beginDrag(props) {
    const { position } = props

    return { position }
  },
}

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
  }
}

export default DragSource('piece', pieceSource, collect)(Piece)
